var map = {
	"./404.vue": [
		"c5Mg",
		0,
		12
	],
	"./About.vue": [
		"en7K",
		32
	],
	"./Contact.vue": [
		"uRks",
		0,
		9
	],
	"./DMCAPolicy.vue": [
		"6E3M",
		0,
		11
	],
	"./Fighters.vue": [
		"gitC",
		0,
		10
	],
	"./FightersView.vue": [
		"tIvU",
		0,
		2
	],
	"./Home.vue": [
		"HXef",
		1,
		0
	],
	"./JoinCommunity.vue": [
		"w0z9",
		0,
		6
	],
	"./Media.vue": [
		"/mEk",
		0,
		5
	],
	"./News.vue": [
		"3b1P",
		0,
		7
	],
	"./NewsView.vue": [
		"DsXt",
		0,
		8
	],
	"./RedeemCode.vue": [
		"vXRu",
		0,
		4
	],
	"./SignUp.vue": [
		"MIHL",
		0,
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "A14c";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages lazy ^\.\/.*\.vue$
// module id = A14c
// module chunks = 34